import { useFirestoreDocument } from '@react-query-firebase/firestore';
import Blocks from 'editorjs-blocks-react-renderer';
import { collection, doc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { db } from '../lib/firebase';

const config = {
  paragraph: {
    className: 'px-3 text-base text-opacity-70',
    actionsClassNames: {
      alignment: 'text-{alignment}', // This is a substitution placeholder: left or center.
    },
  },
  header: {
    className: 'px-3 font-bold',
  },
  embed: {
    className: 'px-3 w-full aspect-video',
  },
  delimiter: {
    className: 'border border-2 w-16 mx-auto',
  },
  list: {
    className: 'px-3 list-inside',
  },
  image: {
    className: 'w-full max-w-screen-md px-3',
    actionsClassNames: {
      stretched: 'w-full h-80 object-cover px-0',
      withBorder: 'border border-2',
      withBackground: 'p-2',
    },
  },
};

export const Home = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <img src="/img/logo.png" alt="SHE" className="w-48 h-auto" />
    </div>
  );
};

const Loading = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner />
    </div>
  );
};

const BlocksRenderer = ({ data }: { data: any }) => {
  return (
    <div className="py-6">
      <div className="max-w-3xl mx-auto space-y-5">
        <Blocks data={data} config={config} />
      </div>
    </div>
  );
};

export const Notice = ({ locale }: { locale?: string }) => {
  const { id } = useParams();
  const collectionName = locale ? `notices_${locale}` : 'notices';

  const ref = doc(collection(db, collectionName), id);
  const item = useFirestoreDocument([collectionName, id], ref);

  if (item.isLoading) return <Loading />;

  const snapshot = item.data;
  const dataFromEditor = snapshot?.data()?.body;
  if (!dataFromEditor) return <></>;

  return <BlocksRenderer data={dataFromEditor} />;
};

export const FAQ = ({ locale }: { locale?: string }) => {
  const { id } = useParams();
  const collectionName = locale ? `faqs_${locale}` : 'faqs';

  const ref = doc(collection(db, collectionName), id);
  const item = useFirestoreDocument([collectionName, id], ref);

  if (item.isLoading) return <Loading />;

  const snapshot = item.data;
  const dataFromEditor = snapshot?.data()?.body;
  if (!dataFromEditor) return <></>;

  return <BlocksRenderer data={dataFromEditor} />;
};

export const Ticket = () => {
  const { id } = useParams();

  const collectionRef = collection(db, 'tickets');
  const ref = doc(collectionRef, id);

  const item = useFirestoreDocument(['tickets', id], ref);

  if (item.isLoading) return <Loading />;

  const snapshot = item.data;
  const dataFromEditor = snapshot?.data()?.answer;

  return <BlocksRenderer data={dataFromEditor} />;
};
